export interface Customer {
    name: string;
    phone_number: string;
    relation_type: string;
}

export interface AddressFrom {
    region_code: string;
    latitude?: number;
    longitude?: number;
    address: string;
    comment: string;
}

export interface CourierCallPost {
    product_code: string;
    product_type: string;
    courier_arrived_date: string | Date | null;
    customers: Customer[] | Customer;
    address_from: AddressFrom;
    region_code: string;
    branch_code: string;
    total_weight: number | string;
    payment_type: string;
    item_count: number | string;
}

export function initCourierCallPost(): CourierCallPost {
    return {
        address_from: {
            address: '',
            comment: '',
            region_code: '',
        },
        region_code: '',
        branch_code: '',
        courier_arrived_date: null,
        product_code: 'CC',
        total_weight: '',
        product_type: '',
        item_count: '',
        payment_type: '',
        customers: {
            name: '',
            phone_number: '',
            relation_type: 'SENDER',
        },
    };
}
